/* eslint-env jest */
import { specLine, detailCopy } from './productCopy';

const addon = ({ description = '', tagline = '', cssName = 'coffeecup' } = {}) => (
  { description, tagline, cssName }
);

describe('specLine', () => {
  it('uses the description when there is one', () => {
    expect(specLine(addon({ description: 'Set of 25 Announcements' }))).toBe('Set of 25 Announcements');
  });

  it('falls back to the tagline', () => {
    expect(specLine(addon({ tagline: 'Keep your favorite smile with you' })))
      .toBe('Keep your favorite smile with you');
  });

  // THE BUG THIS EXISTS FOR: "coffeecup" reached a live product page as a
  // bullet. It is the add-on's own css_name sitting in the tagline column.
  it('rejects a value that is just the product slug', () => {
    expect(specLine(addon({ tagline: 'coffeecup', cssName: 'coffeecup' }))).toBeNull();
  });

  it('matches a slug regardless of case or spacing', () => {
    expect(specLine(addon({ tagline: 'Coffee Cup', cssName: 'coffeecup' }))).toBeNull();
    expect(specLine(addon({ tagline: 'eightbyten_G', cssName: 'eightbytenG' }))).toBeNull();
  });

  it('keeps real copy that merely resembles the product name', () => {
    expect(specLine(addon({ tagline: '15 oz ceramic coffee cup', cssName: 'coffeecup' })))
      .toBe('15 oz ceramic coffee cup');
  });

  it('takes only the first line when a field holds several', () => {
    expect(specLine(addon({ description: 'Set of 25 Announcements\r\n5x7" Flat Card' })))
      .toBe('Set of 25 Announcements');
  });

  it('returns null rather than an empty string when there is nothing to say', () => {
    expect(specLine(addon())).toBeNull();
    expect(specLine(undefined)).toBeNull();
  });
});

describe('detailCopy', () => {
  it('reads the first line as the sentence and the rest as bullets', () => {
    const { lead, bullets } = detailCopy(addon({
      description: 'Set of 25 Announcements\r\n5x7" Flat Card\r\nEnvelopes included',
    }));

    expect(lead).toBe('Set of 25 Announcements');
    expect(bullets).toEqual(['5x7" Flat Card', 'Envelopes included']);
  });

  it('drops the slug here too, not just from the spec line', () => {
    const { lead, bullets } = detailCopy(addon({ tagline: 'coffeecup', cssName: 'coffeecup' }));

    expect(lead).toBeNull();
    expect(bullets).toEqual([]);
  });

  it('spans both columns, description first', () => {
    const { lead, bullets } = detailCopy(addon({ description: 'A keepsake mug', tagline: '15 oz ceramic' }));

    expect(lead).toBe('A keepsake mug');
    expect(bullets).toEqual(['15 oz ceramic']);
  });

  it('survives an add-on with no copy at all', () => {
    expect(detailCopy(addon())).toEqual({ lead: null, bullets: [] });
    expect(detailCopy(undefined)).toEqual({ lead: null, bullets: [] });
  });
});

// ⚠️ REAL ROWS, 2026-09-29. Six live announcement add-ons carry an expired promo
// in `description`/`tagline`, and this page promotes `description` to the line
// under the product's name -- so id 50 was about to headline "20% OFF! Code:
// NEWYEAR" and id 53 to offer 50% off with CYBER2025, on a page whose banner
// carries the REAL offer.
describe('offer claims in product copy', () => {
  it.each([
    ['20% OFF! Code: NEWYEAR'],
    ['50% OFF! Code: CYBER2025'],
    ['Code: SPRING24'],
    ['25% off everything'],
  ])('never uses %s as the spec line', (text) => {
    expect(specLine({ description: text, cssName: 'gradannouncement' })).toBeNull();
  });

  it('never uses one as a Details bullet either', () => {
    const { lead, bullets } = detailCopy({
      description: 'Set of 25 flat cards.',
      tagline: '50% OFF! Code: CYBER2025',
      cssName: 'gradplaid',
    });

    expect(lead).toBe('Set of 25 flat cards.');
    expect(bullets).not.toContain('50% OFF! Code: CYBER2025');
  });

  // The guard is narrow on purpose: ordinary copy that happens to mention a
  // number or the word "off" must survive.
  it('leaves ordinary copy alone', () => {
    expect(specLine({ description: 'Set of (2) 4x5" Photo Magnets', cssName: 'magnet' }))
      .toBe('Set of (2) 4x5" Photo Magnets');
    expect(specLine({ description: 'Peel the backing off before mounting.', cssName: 'magnet' }))
      .toBe('Peel the backing off before mounting.');
  });
});

describe('detail_line', () => {
  // The column existed, was served, and was editable on /admin/addons under a
  // label promising it appears "under the name on Announcements & Gifts" -- and
  // nothing rendered it. An admin typed a spec in and saw no change anywhere.
  it('wins over description, because its meaning is the one that is known', () => {
    expect(specLine({
      detailLine: 'Set of 25',
      description: 'Whatever this season staff typed here',
      cssName: 'gradannouncement',
    })).toBe('Set of 25');
  });

  it('falls back to description when it is blank', () => {
    expect(specLine({ detailLine: '   ', description: 'Set of 25', cssName: 'x' })).toBe('Set of 25');
  });
});
